module.exports = __webpack_public_path__ + "static/media/Gotham-Bold.9c35bf87.otf";